import { useEffect, Fragment } from 'react'
import { ModalNodeProps } from '../../../../components/modal.component'
import { QuoteDetailPDF } from '../new-quote-modal'
import { Quote2ServiceDto, BOOKING_TYPE, PaymentTerm } from '../../../../../definition'
import {
  getPaymentTermLlabel,
  renderBillingAddress,
  renderDiscountLabel,
  renderDiscountPromo,
  renderDiscountValue
} from '../../../../../utils'
import moment from 'moment'
import companyLogo from './../../../../../styles/images/left-nav/company-icon.png'
import { SWITCH_FUNCTION } from '../../../../../constants'
import Scissor from './../../../../../styles/images/scissors.png'
import { company_registration_id } from '../../../../../constants/specific'
import { getEachServiceSimpleAmount, quoteCalculation } from '../../../../../utils'
import { CONTRACT_DURATION } from '../../../../../constants/booking.config'

export default function QuotePDF(props: ModalNodeProps<QuoteDetailPDF>) {
  useEffect(() => {
    setTimeout(() => {
      props.onClose && props.onClose()
    }, 5000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { subTotal, totalDiscount, amountAfterDiscount, totalTax, finalTotal } = quoteCalculation({
    services: props.input?.services,
    promoCodeUsed: props.input?.promoCodeUsed,
    gst: props?.input?.gst,
    surcharge: props.input?.surcharge,
    serviceCharge: props.input?.serviceCharge
  })

  if (SWITCH_FUNCTION.pdf_ver2) {
    return (
      <div className='quote-detail-pdf-ver2'>
        <img
          src={props.input?.companyInfo?.logo || companyLogo}
          crossOrigin='anonymous'
          alt='company-logo'
          className='company-logo'
        />
        <div className='general-information'>
          <div className='header'>
            <h3 className='invoice-header'>QUOTE</h3>
            <div className='customer-infor'>
              <span>{props.input?.customer?.profile?.name}</span>
              <br />
              {renderBillingAddress(props.input?.booking?.bookedServices?.[0])}
            </div>
          </div>
          <div>
            <div>
              <label>Quote Date</label>
              <p>{moment(props.input?.date).format('DD-MM-YYYY')}</p>
            </div>
            <div>
              <label>Quote Number</label>
              <p>{props.input?.quoteNo}</p>
            </div>
            <div>
              <label>Reference</label>
              <p>{props.input?.serviceType}</p>
            </div>
          </div>
          <div className='address'>
            <span>
              {props?.input?.companyInfo?.name}
              <br />
              {props?.input?.companyInfo?.addressLine1}
              <br />
              {props?.input?.companyInfo?.addressLine2}
              <br />
              Singapore, {props?.input?.companyInfo?.postalCode}
              <br />
              Tel: {props?.input?.companyInfo?.tel}
              <br />
              Email:
              <br />
              {props?.input?.companyInfo?.email}
            </span>
          </div>
        </div>
        <table className='services'>
          <thead className='services-header'>
            <tr>
              <th>Description</th>
              <th>Quantity</th>
              <th>Unit Price</th>
              <th>Tax</th>
              <th>Discount</th>
              <th>Amount SGD</th>
            </tr>
          </thead>
          <tbody>
            {props.input?.services?.map((service: Quote2ServiceDto, index: number) => {
              return (
                <Fragment key={index}>
                  <tr>
                    <td className='service-note'>{service.service?.name}</td>
                    <td>{(service.durationInYears || 1) * (service.timesPerYear || 1) * (service.quantity || 1)}</td>
                    <td>{service.amount}</td>
                    <td>{props?.input?.gst}%</td>
                    <td>
                      {renderDiscountValue(service, props.input?.promoCodeUsed)}
                      {renderDiscountLabel(service, props.input?.promoCodeUsed)}
                    </td>
                    <td>{getEachServiceSimpleAmount(service)}</td>
                  </tr>
                  <tr>
                    <td style={{ whiteSpace: 'pre-line' }}>{service.notes}</td>
                  </tr>
                </Fragment>
              )
            })}
          </tbody>
        </table>
        <div className='total'>
          <div className='total-item'>
            <p>Subtotal</p>
            <p>{subTotal.toFixed(2)}</p>
          </div>
          <div className='total-item total-item-discount'>
            <p>Total Discount{renderDiscountPromo(props.input?.promoCodeUsed)}</p>
            <p>{totalDiscount.toFixed(2)}</p>
          </div>
          {totalTax > 0 && (
            <div className='total-item'>
              <p>Amount After Discount</p>
              <p>{amountAfterDiscount.toFixed(2)}</p>
            </div>
          )}
          {props.input?.surcharge ? (
            <div className='total-item'>
              <p>Surcharge</p>
              <p>{props.input?.surcharge.toFixed(2)}</p>
            </div>
          ) : null}
          {props.input?.serviceCharge ? (
            <div className='total-item'>
              <p>Platform Fee</p>
              <p>{props.input?.serviceCharge.toFixed(2)}</p>
            </div>
          ) : null}
          {totalTax > 0 && (
            <div className='total-item'>
              <p>TOTAL TAX {props?.input?.gst}%</p>
              <p>{totalTax.toFixed(2)}</p>
            </div>
          )}
          <div className='total-item last'>
            <p>TOTAL SGD</p>
            <p>{finalTotal.toFixed(2)}</p>
          </div>
        </div>
        <div className='specific-infor'>
          <div className='specific-infor-detail'>
            <div>
              <label>Payment Terms</label>
            </div>
            <div>{getPaymentTermLlabel(props.input?.paymentTerm as PaymentTerm)}</div>
          </div>
          {props.input?.paymentTerm === PaymentTerm.CREDIT && (
            <div className='specific-infor-detail'>
              <div>
                <label>Duration (days)</label>
              </div>
              <div>{props.input.paymentTermValue}</div>
            </div>
          )}
          {props.input?.paymentTerm === PaymentTerm.PPP && (
            <div className='specific-infor-detail'>
              <div>
                <label>Partial Payment Percentage(%)</label>
              </div>
              <div>{props.input.paymentTermValue}</div>
            </div>
          )}
        </div>
        <div className='term'>
          <span className='due-date'>Due Date: {moment(props.input?.date).format('DD-MM-YYYY')}</span>
          <div className='term-content' style={{ whiteSpace: 'pre-line' }}>
            {props.input?.quoteTerms}
          </div>
        </div>
        <div className='footer-pdf'>
          <img src={Scissor} className='footer-pdf-icon' />
          <div>
            <h3 className='footer-pdf-header'>PAYMENT ADVICE</h3>
            <div className='footer-pdf-company'>
              <span>
                {props?.input?.companyInfo?.name}
                <br />
                {props?.input?.companyInfo?.addressLine1}
                <br />
                {props?.input?.companyInfo?.addressLine2}
                <br />
                Singapore, {props?.input?.companyInfo?.postalCode}
                <br />
                Tel: {props?.input?.companyInfo?.tel}
                <br />
                Email: {props?.input?.companyInfo?.email}
              </span>
            </div>
          </div>
          <div className='footer-pdf-sumup'>
            <div className='footer-pdf-sumup-item'>
              <label>Customer</label>
              <span>{props.input?.customerName}</span>
            </div>
            <div className='footer-pdf-sumup-item break-line'>
              <label>Quote Number</label>
              <span>{props.input?.quoteNo}</span>
            </div>
            <div className='footer-pdf-sumup-item'>
              <label>Amount Due</label>
              <label>{finalTotal.toFixed(2)}</label>
            </div>
            <div className='footer-pdf-sumup-item break-line'>
              <label>Due Date</label>
              <span>{moment(props.input?.date).format('DD-MM-YYYY')}</span>
            </div>
            <div className='footer-pdf-sumup-item'>
              <label>Amount Enclosed</label>
              <span className='sign'> </span>
            </div>
          </div>
        </div>
        <div className='last-line'>
          Company Registration No: {props.input?.companyInfo?.registrationNo || company_registration_id}. Registered
          Office: {props.input?.companyInfo?.addressLine1}, {props.input?.companyInfo?.addressLine2},{' '}
          {props.input?.companyInfo?.postalCode}, Singapore.
        </div>
      </div>
    )
  } else {
    return (
      <div className='quote-detail-pdf'>
        <div className='company-information'>
          <div className='company-infor'>
            <div className='company-infor-detail'>
              <img src={props.input?.companyInfo?.logo || companyLogo} crossOrigin='anonymous' alt='company-logo' />
            </div>
          </div>
          <div className='company-infor'>
            <div className='company-infor-detail'>
              <div>
                <span>
                  {props?.input?.companyInfo?.addressLine1}
                  <br />
                  {props?.input?.companyInfo?.addressLine2}
                  <br />
                  Singapore, {props?.input?.companyInfo?.postalCode}
                </span>
              </div>
            </div>
          </div>
          <div className='company-infor'>
            <div className='company-infor-detail'>
              <div>
                <span>Tel: </span>
                <span>{props?.input?.companyInfo?.tel}</span>
              </div>
            </div>
          </div>
          <div className='company-infor'>
            <div className='company-infor-detail'>
              <div>
                <span>Email: </span>
                <span>{props?.input?.companyInfo?.email}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='general-infor'>
          <div>
            <label>Customer Name</label>
            <p>{props.input?.customerName}</p>
          </div>
          <div>
            <label>Quote</label>
            <p>{props.input?.quoteNo}</p>
          </div>
          <div>
            <label>Service Type</label>
            <p>{props.input?.serviceType}</p>
          </div>
          <div>
            <label>Date</label>
            <p>{moment(props.input?.date).format('DD-MM-YYYY')}</p>
          </div>
        </div>
        <div className='services'>
          {props.input?.services?.map((service: Quote2ServiceDto, index: number) => {
            return (
              <div key={index}>
                <div className='service'>
                  <div className='service-detail'>
                    <div>
                      <label>Service Name</label>
                      <div className='service-detail-field h-100'>
                        {props.input?.serviceOptions.find((option) => option.value === service.serviceId)?.label}
                      </div>
                    </div>
                  </div>
                  <div className='service-detail'>
                    <div>
                      <label>Service Description</label>
                      <div className='service-detail-field h-100'>{service.service?.description}</div>
                    </div>
                  </div>
                  <div className='service-detail'>
                    <div>
                      <label>Notes</label>
                      <div className='service-detail-field h-100'>{service.notes}</div>
                    </div>
                  </div>
                  <div className='service-detail'>
                    <div>
                      <label>Quantity</label>
                      <div className='service-detail-field h-100'>{service.quantity}</div>
                    </div>
                  </div>
                </div>
                <div className='service'>
                  <div className='service-detail'>
                    {props.input?.serviceType === BOOKING_TYPE.RECURRING && (
                      <div>
                        <label>Number of Times Per {CONTRACT_DURATION.toLowerCase()}</label>
                        <div className='service-detail-field'>{service.timesPerYear}</div>
                      </div>
                    )}
                  </div>
                  <div className='service-detail'>
                    {props.input?.serviceType === BOOKING_TYPE.RECURRING && (
                      <div>
                        <label>Contract Duration(Years)</label>
                        <div className='service-detail-field'>{service.durationInYears}</div>
                      </div>
                    )}
                  </div>
                  <div className='service-detail'>
                    <div>
                      <label>Discount({renderDiscountLabel(service, props.input?.promoCodeUsed)})</label>
                      <div className='service-detail-field'>
                        {renderDiscountValue(service, props.input?.promoCodeUsed)}
                      </div>
                    </div>
                  </div>
                  <div className='service-detail'>
                    <div>
                      <label>Amount($)</label>
                      <div className='service-detail-field'>{service.amount}</div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div className='summary'>
          <div className='summary-detail'>
            <div>
              <label>Subtotal</label>
            </div>
            <div>{subTotal.toFixed(2)}</div>
          </div>
          <div className='summary-detail'>
            <div>
              <label>Discount{renderDiscountPromo(props.input?.promoCodeUsed)}</label>
            </div>
            <div>{totalDiscount.toFixed(2)}</div>
          </div>
          {totalTax > 0 && (
            <div className='summary-detail'>
              <div>
                <label>Amount after discount</label>
              </div>
              <div>{(subTotal - totalDiscount).toFixed(2)}</div>
            </div>
          )}
          {props.input?.serviceCharge ? (
            <div className='summary-detail'>
              <div>
                <label>Platform Fee</label>
              </div>
              <div>{props.input?.serviceCharge}</div>
            </div>
          ) : null}
          {totalTax > 0 && (
            <div className='summary-detail'>
              <div>
                <label>GST {props?.input?.gst}%</label>
              </div>
              <div>{totalTax.toFixed(2)}</div>
            </div>
          )}
          <div className='summary-detail summary-detail--total'>
            <div>
              <label>Total</label>
            </div>
            <div>{finalTotal.toFixed(2)}</div>
          </div>
        </div>
        <div className='specific-infor'>
          <div className='specific-infor-detail'>
            <div>
              <label>Payment Terms</label>
            </div>
            <div>{getPaymentTermLlabel(props.input?.paymentTerm as PaymentTerm)}</div>
          </div>
          {props.input?.paymentTerm === PaymentTerm.CREDIT && (
            <div className='specific-infor-detail'>
              <div>
                <label>Duration (days)</label>
              </div>
              <div>{props.input?.paymentTermValue}</div>
            </div>
          )}
          {props.input?.paymentTerm === PaymentTerm.PPP && (
            <div className='specific-infor-detail'>
              <div>
                <label>Partial Payment Percentage(%)</label>
              </div>
              <div>{props.input?.paymentTermValue}</div>
            </div>
          )}
        </div>
        <div className='term'>
          <div>
            <label>Terms</label>
          </div>
          <div style={{ whiteSpace: 'pre-line' }}>{props?.input?.quoteTerms}</div>
        </div>
      </div>
    )
  }
}
